import React, { useEffect, useState } from "react";
import { Modal, List, Loader } from "rsuite";
import { SharedApi } from "../../../services/Shared.api";
import "./DeviceModal.scss";
import {DeviceListItem, DevicesModalProps, DevicesResponse} from "../modals.model";

const DevicesModal = ({ open, deviceId, onClose, onSelectDevice }: DevicesModalProps) => {
  const [devices, setDevices] = useState<DeviceListItem[]>([]);
  const [loading, setLoading] = useState(false);

  const loadDevices = async () => {
    if (!deviceId) return;
    try {
      setLoading(true);
      const response = (await SharedApi.getDevices(deviceId as string)) as DevicesResponse;
      const { clocks = [], sensors = [] } = response || {};

      const list: DeviceListItem[] = [
        ...clocks.map((item) => ({ ...item, kind: "clock" as const })),
        ...sensors.map((item) => ({ ...item, kind: "sensor" as const })),
        {
          id: "coordinates",
          kind: "coords",
          model: "По координатам",
          article: "",
          address: "",
          isConnected: true
        }
      ];

      setDevices(list);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      loadDevices().then();
    }
  }, [open, deviceId]);

  const handleSelect = (device: DeviceListItem) => {
    if (onSelectDevice) {
      onSelectDevice(device);
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="sm" className="devices-modal">
      <Modal.Header>
        <Modal.Title className="devices-modal__title">Устройства с датчиками</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="devices-modal__loader">
            <Loader />
          </div>
        ) : devices.length ? (
          <List bordered hover>
            {devices.map((dev) => (
              <List.Item
                key={dev.id}
                className="devices-modal__item"
                onClick={() => handleSelect(dev)}
              >
                {dev.kind === "coords" ? (
                  <>
                    <div className="devices-modal__item-title">По координатам</div>
                    <div className="devices-modal__item-subtitle">
                      Используются координаты устройства
                    </div>
                  </>
                ) : (
                  <>
                    <div className="devices-modal__item-title">
                      {dev.kind === "clock" ? "Часовой механизм" : "Блок датчиков"} {dev.model}
                    </div>
                    <div className="devices-modal__item-subtitle">
                      Арт.: {dev.article} · {dev.address} · {dev.isConnected ? "Онлайн" : "Офлайн"}
                    </div>
                  </>
                )}
              </List.Item>
            ))}
          </List>
        ) : (
          <div className="devices-modal__empty">
            Нет доступных устройств
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DevicesModal;
